<!--
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2020-12-14 08:16:56
 * @LastEditors: sjq
 * @LastEditTime: 2021-09-29 11:17:07
-->
<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="minlogo" :src="minlogo" class="sidebar-logo minlogo" />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <div v-if="ENV !== 'production'" class="version">v{{ version }}</div>
        <img v-if="logo" :src="logo" class="sidebar-logo biglogo" />
        <!-- <h1 v-if="logo" class="sidebar-title">{{ title }}</h1> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
import config from '../../../../../package.json'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '拾光伴学集团管理后台',
      minlogo: require('./minlogo.png'),
      logo: require('./logo.png'),
      version: config.version, // 获取包的信息
      ENV: process.env.NODE_ENV
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 70px;
  // line-height: 70px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  & .version {
    position: absolute;
    color: #fff;
    right: 8px;
    font-size: 12px;
    bottom: 6px;
  }
  & .biglogo {
    width: 140px;
    top: 15px;
    bottom: 20px;
    left: 15px;
  }
  & .minlogo {
    width: 26px;
    left: 0;
    right: 0;
    top: 12px;
  }
  & .sidebar-logo-link {
    position: relative;
    width: 100%;
    height: var(--sidebarLogoContainerHeight);
    line-height: var(--sidebarLogoContainerHeight);
    // background: #212837;
    text-align: center;
    overflow: hidden;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    & .sidebar-logo {
      // width: 32px;
      // height: 32px;
      vertical-align: middle;
      position: absolute;
      margin: 0 auto;
    }

    & .sidebar-title {
      position: absolute;
      left: 20px;
      bottom: 0px;
      display: inline-block;
      margin: 0;
      color: #ccc;
      line-height: 60px;
      font-size: 12px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: bottom;
      letter-spacing: 5px;
    }
  }
}
</style>
